import React from "react";
import MDBox from "components/MDBox";
import { useUnmatch } from "../services/useUnMatch";
import UnmatchHeader from "./UnMatchHeader";
import UnmatchTable from "./UnMatchTable";

const Unmatch: React.FC = () => {
  const {
    phaseData,
    selectedRows,
    tableData,
    page,
    rowsPerPage,
    totalCount,
    loading,
    error,
    unmatchLoading,
    allColumns,
    handleSelectRow,
    handleSelectAll,
    handleUnmatch,
    handleChangePage,
    handleChangeRowsPerPage,
    handleResultsView,
  } = useUnmatch();

  return (
    <MDBox
      sx={{
        borderRadius: "0",
        boxShadow: "none",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: "1rem",
      }}
    >
      <UnmatchHeader phaseData={phaseData} selectedRows={selectedRows} handleResultsView={handleResultsView} />
      <UnmatchTable
        tableData={tableData}
        selectedRows={selectedRows}
        allColumns={allColumns}
        loading={loading}
        error={error}
        unmatchLoading={unmatchLoading}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        handleSelectRow={handleSelectRow}
        handleSelectAll={handleSelectAll}
        handleUnmatch={handleUnmatch}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </MDBox>
  );
};

export default Unmatch;
